/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GrowthAllocationEnriched } from './GrowthAllocationEnriched';
import {
    GrowthAllocationEnrichedFromJSON,
    GrowthAllocationEnrichedFromJSONTyped,
    GrowthAllocationEnrichedToJSON,
} from './GrowthAllocationEnriched';

/**
 * 
 * @export
 * @interface GrowthAllocationPage
 */
export interface GrowthAllocationPage {
    /**
     * 
     * @type {Array<GrowthAllocationEnriched>}
     * @memberof GrowthAllocationPage
     */
    growthAllocation: Array<GrowthAllocationEnriched>;
    /**
     * 
     * @type {number}
     * @memberof GrowthAllocationPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof GrowthAllocationPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the GrowthAllocationPage interface.
 */
export function instanceOfGrowthAllocationPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "growthAllocation" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function GrowthAllocationPageFromJSON(json: any): GrowthAllocationPage {
    return GrowthAllocationPageFromJSONTyped(json, false);
}

export function GrowthAllocationPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrowthAllocationPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'growthAllocation': ((json['growth_allocation'] as Array<any>).map(GrowthAllocationEnrichedFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function GrowthAllocationPageToJSON(value?: GrowthAllocationPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'growth_allocation': ((value.growthAllocation as Array<any>).map(GrowthAllocationEnrichedToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

